import { Button, Card, Col, Flex, Input, List, Table, Typography } from "antd";
import { Form } from "antd";
import { Row } from "antd";
import { Collapse } from "antd";
import { Modal } from "antd";
import React, { FC, useEffect } from "react";
import ViewEnhancementDocumentIhx from "./ViewEnhancementDocumentIhx";
import { EyeOutlined } from "@ant-design/icons";

type ViewEnhancementIhxProps = {
  closeViewAddedEnhancement: any;
  viewEnhancement: boolean;
  handleOpen: any;
  isFetchingEnhancementData: boolean;
  enhancementData: any;
};

const { Panel } = Collapse;
const { Text } = Typography;

const ViewEnhancementIhx: FC<ViewEnhancementIhxProps> = ({
  viewEnhancement,
  closeViewAddedEnhancement,
  handleOpen,
  isFetchingEnhancementData,
  enhancementData,
}) => {

  const totalFields = [
    "packages",
    "roomRentAndNursingCharge",
    "consultation",
    "otCharge",
    "surgeonAndAnesthetist",
    "investigation",
    "medicineAndConsumables",
    "otherHospitalExpenses",
  ];

  const calculateTotal = (values: any) => {
    const total = totalFields?.reduce((sum, field) => {
      const value = parseFloat(values[field]) || 0;
      return sum + value;
    }, 0);

    return total;
  }
  return (
    <div>
      <Modal
        loading={isFetchingEnhancementData}
        title={
          <div>
            <span style={{ fontSize: "1rem", fontWeight: "600" }}>
              ENHANCEMENT
            </span>
          </div>
        }
        centered
        width={2000}
        open={viewEnhancement}
        onCancel={closeViewAddedEnhancement}
        footer={null}
        style={{ boxShadow: "0px 4px 20px 0px #00000040", width: "149%" }}
        className="new-view-enhancement-ihx"
      >
        {enhancementData?.length > 0 ? (
          <List
            grid={{ gutter: 16, column: 1 }}
            dataSource={enhancementData}
            renderItem={(enhancement: any, index) => (
              <List.Item>
                <Card
                  className="enhancement-card"
                  title={`Enhancement-${enhancementData?.length - index}`}
                  style={{ cursor: "pointer", backgroundColor: "white" }}
                >
                  <Collapse defaultActiveKey={[index === 0 ? "1" : ""]}>
                    <Panel header="Basic Details" key="1">
                      <Form>
                        <Row
                          key={enhancement?.id}
                          gutter={[16, 16]}
                          align="top"
                          style={{
                            border: "1px solid #004C8F",
                            padding: "10px 20px",
                            borderRadius: "16px",
                            marginBottom: "0.8rem",
                            background: "white",
                            boxShadow: "0px 2px 8px 0px #00000040",
                          }}
                        >
                          <Col span={8}>
                            <Form.Item
                              label="Date of Admission"
                              name={"dateOfAdmission"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={enhancement?.dateOfAdmission}
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="Date Of Discharge"
                              name={"dateOfDischarge"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={enhancement?.dateOfDischarge}
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="Remarks"
                              name={"remarks"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                style={{
                                  borderRadius: "5px",
                                  color: "black",
                                }}
                                disabled={true}
                                defaultValue={enhancement?.remarks}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </Panel>
                    <Panel header="Billing Details" key="2">
                      <Form>
                        <Row
                          key={enhancement?.id}
                          gutter={[16, 16]}
                          align="top"
                          style={{
                            border: "1px solid #004C8F",
                            padding: "10px 20px",
                            borderRadius: "16px",
                            marginBottom: "0.8rem",
                            background: "white",
                            boxShadow: "0px 2px 8px 0px #00000040",
                          }}
                        >
                          <Col span={8}>
                            <Form.Item
                              label="Package"
                              name={"package"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={enhancement?.packages}
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="ROOM & NURSING CHARGE"
                              name={"roomRentAndNursingCharge"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={
                                  enhancement?.roomRentAndNursingCharge
                                }
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="CONSULTATION"
                              name={"consultation"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                style={{
                                  borderRadius: "5px",
                                  color: "black",
                                }}
                                disabled={true}
                                defaultValue={enhancement?.consultation}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="OT CHARGES"
                              name={"otCharges"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={enhancement?.otCharge}
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="SURGEON & ANESTHETIST"
                              name={"surgeonAndAnesthetist"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={
                                  enhancement?.surgeonAndAnesthetist
                                }
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="INVESTIGATION"
                              name={"investigation"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={enhancement?.investigation}
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="MEDICINE & CONSUMABLES"
                              name={"medicineAndConsumables"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={
                                  enhancement?.medicineAndConsumables
                                }
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="OTHER HOSPITAL EXPENSES"
                              name={"otherHospitalExpenses"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={enhancement?.otherHospitalExpenses}
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="Total"
                              name={"total"}
                              // rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={'₹' + calculateTotal(enhancement) + '/-'}
                                disabled={true}
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </Panel>
                    <Panel header="Documents Uploaded" key="3">
                      {
                        enhancement?.enhancementDocuments?.length > 0 ? 
                        <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(6, 1fr)",
                          gap: 10,
                        }}
                      >
                        {
                          enhancement?.enhancementDocuments?.map(
                            (doc: any) => (
                              <div
                                key={doc.id}
                                style={{
                                  border: "1px solid #eee",
                                  padding: 10,
                                  borderRadius: 8,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>
                                  {doc.documentLabelType || doc.documentName}
                                </span>
                                <Button
                                  type="link"
                                  icon={<EyeOutlined />}
                                  onClick={() =>
                                    handleOpen(
                                      enhancement?.enhancementDocuments,
                                      doc?.documentLabelType
                                    )
                                  }
                                />
                              </div>
                            )
                          )
                        }
                      </div> : <p style={{textAlign: "center", marginBottom: 0}}>No Document Uploaded</p>
                      }
                    </Panel>
                  </Collapse>
                </Card>
              </List.Item>
            )}
          />
        ) : (
          <></>
        )}
      </Modal>
    </div>
  );
};

export default ViewEnhancementIhx;
